export default __webpack_public_path__ + "static/media/restaurant-icon.afc87bb5.svg";